(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-aparatologia-b2b"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aparatologia-b2b')) {
    class AparatologiaB2b extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.root = this.closest('[data-ab2b-section]');
        this.data = JSON.parse(this.querySelector('[data-ab2b-data]').textContent);
        this.current = this.data.variants.find(item => String(item.id) === this.dataset.initialVariant);
        const variantInput = this.querySelector('[data-product-select]');
        if (variantInput) variantInput.disabled = false;
        this.slider = this.querySelector('[data-ab2b-slider]');
        this.dialog = this.querySelector('[data-ab2b-dialog]');
        this.thumbs = [...this.querySelectorAll('[data-ab2b-thumbnail]')];
        this.thumbNav = this.querySelector('[data-ab2b-thumbs]');
        this.thumbViewport = this.querySelector('[data-ab2b-thumbs-viewport]');
        this.thumbButtons = [...this.querySelectorAll('[data-ab2b-thumb-direction]')];
        this.nativeSlider = null;
        this.onChange = () => this.updateThumbnails();
        const options = { signal: this.abort.signal };
        this.thumbViewport?.addEventListener('scroll', () => this.updateThumbControls(), { ...options, passive: true });
        this.thumbResize = new ResizeObserver(() => {
          const width = this.slider?.getBoundingClientRect().width || 0;
          if (Math.abs(width - (this.thumbSliderWidth || 0)) > .5) {
            this.thumbSliderWidth = width;
            this.nativeSlider?.resize();
          }
          this.queueThumbLayout();
        });
        if (this.thumbNav && this.slider) {
          this.thumbResize.observe(this.slider);
          this.thumbResize.observe(this.thumbViewport);
        }
        this.addEventListener('click', event => this.onClick(event), options);
        this.addEventListener('keydown', event => this.onKeydown(event), options);
        this.addEventListener('change', event => {
          if (event.target.matches('[data-ab2b-variant]')) this.selectVariant(event.target.value);
        }, options);
        this.addEventListener('submit', event => this.onSubmit(event), { ...options, capture: true });
        this.addEventListener('playing', event => {
          const media = event.target.closest('[data-product-single-media-wrapper]');
          if (media && (media.dataset.id !== this.activeMediaId() || this.dialog?.open)) event.target.pause();
        }, { ...options, capture: true });
        this.root.addEventListener('theme:variant:change', event => {
          const variant = event.detail?.variant;
          this.current = this.data.variants.find(item => item.id === variant?.id) || null;
          this.syncVariant();
          this.selectMedia(this.current?.media || this.dataset.defaultMedia);
        }, options);
        document.addEventListener('DOMContentLoaded', () => this.connectGallery(), options);
        window.addEventListener('load', () => this.connectGallery(), options);
        document.addEventListener('shopify:block:select', event => {
          if (event.detail?.blockId === this.dialog?.dataset.blockId) this.openQuote();
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.pauseMedia();
        }, options);
        this.querySelectorAll('[data-ab2b-quote-trigger]').forEach(trigger => {
          const internal = trigger.hash === `#${this.dataset.quoteId}` || trigger.hash === `#${this.dataset.appTarget}`;
          if (internal && !this.querySelector(`[id="${trigger.hash.slice(1)}"]`)) trigger.setAttribute('aria-disabled', 'true');
        });
        if (this.dialog && typeof this.dialog.showModal === 'function') {
          this.dialog.close();
          this.dialog.setAttribute('data-modal-ready', '');
          this.dialog.addEventListener('click', event => {
            const rect = this.dialog.getBoundingClientRect();
            if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
          }, options);
          this.dialog.addEventListener('close', () => this.trigger?.focus(), options);
          if (this.dialog.querySelector('[data-ab2b-form-result]')) this.openQuote();
        }
        this.observer = new MutationObserver(() => {
          cancelAnimationFrame(this.galleryFrame);
          this.galleryFrame = requestAnimationFrame(() => this.connectGallery());
        });
        if (this.slider) this.observer.observe(this.slider, { attributes: true, attributeFilter: ['class'], childList: true });
        this.connectGallery();
        this.syncVariant();
        this.queueThumbLayout();
      }
      connectGallery() {
        const slider = window.themeVendor?.Flickity?.data(this.slider);
        if (!slider || slider === this.nativeSlider) return;
        this.nativeSlider = slider;
        slider.on('select', this.onChange);
        this.selectMedia(this.current?.media || this.dataset.initialMedia || this.dataset.defaultMedia, true);
        this.updateThumbnails();
      }
      selectMedia(id, immediate = false) {
        if (!this.nativeSlider || !id) return;
        const index = this.nativeSlider.cells.findIndex(cell => cell.element.dataset.id === String(id));
        if (index >= 0) this.nativeSlider.select(index, false, immediate);
      }
      activeMediaId() {
        return this.nativeSlider?.selectedElement?.dataset.id || this.dataset.initialMedia || this.slider?.querySelector('[data-product-single-media-wrapper]')?.dataset.id;
      }
      updateThumbnails() {
        const id = this.nativeSlider?.selectedElement?.dataset.id;
        this.querySelectorAll('[data-product-single-media-wrapper]').forEach(media => {
          if (media.dataset.id !== id) media.dispatchEvent(new CustomEvent('theme:media:hidden'));
        });
        this.thumbs.forEach(thumb => {
          if (thumb.dataset.ab2bThumbnail === id) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
        this.thumbReveal = true;
        this.queueThumbLayout();
      }
      queueThumbLayout() {
        if (!this.thumbNav) return;
        cancelAnimationFrame(this.thumbFrame);
        this.thumbFrame = requestAnimationFrame(() => this.layoutThumbs());
      }
      layoutThumbs() {
        const viewport = this.thumbViewport;
        if (!viewport || !this.isConnected) return;
        this.thumbVertical = getComputedStyle(viewport).flexDirection === 'column';
        if (!this.thumbVertical) {
          const layout = this.thumbNav.closest('.ab2b-gallery__layout');
          const styles = getComputedStyle(layout);
          const share = parseFloat(styles.getPropertyValue(matchMedia('(max-width: 1023px)').matches ? '--thumb-mobile-share' : '--thumb-share'));
          this.thumbNav.style.setProperty('--ab2b-thumb-width', `${layout.clientWidth * share / 100}px`);
        }
        const height = this.slider?.getBoundingClientRect().height || 0;
        this.thumbNav.dataset.ready = height > 0 || !this.thumbVertical ? 'true' : 'false';
        this.thumbNav.style.setProperty('--ab2b-thumbs-height', `${height}px`);
        const top = viewport.scrollTop;
        const left = viewport.scrollLeft;
        this.thumbButtons.forEach(button => { button.hidden = true; });
        this.thumbNav.dataset.overflow = 'false';
        const overflow = this.thumbNav.dataset.mode === 'arrows' && (this.thumbVertical ? viewport.scrollHeight > viewport.clientHeight + 1 : viewport.scrollWidth > viewport.clientWidth + 1);
        this.thumbNav.dataset.overflow = String(overflow);
        this.thumbButtons.forEach(button => { button.hidden = !overflow; });
        if (overflow && this.thumbVertical) {
          const gap = parseFloat(getComputedStyle(this.thumbNav).gap) || 0;
          const minimum = this.thumbs[0].getBoundingClientRect().height + this.thumbButtons.reduce((total, button) => total + button.offsetHeight, 0) + gap * 2 + 8;
          this.thumbNav.style.setProperty('--ab2b-thumbs-height', `${Math.max(height, minimum)}px`);
        }
        if (Math.abs(viewport.scrollTop - top) > 1) viewport.scrollTop = top;
        if (Math.abs(viewport.scrollLeft - left) > 1) viewport.scrollLeft = left;
        if (this.thumbReveal) {
          this.revealThumb();
          this.thumbReveal = false;
        }
        this.updateThumbControls();
      }
      updateThumbControls() {
        if (!this.thumbViewport) return;
        const viewport = this.thumbViewport;
        const position = this.thumbVertical ? viewport.scrollTop : Math.abs(viewport.scrollLeft);
        const maximum = this.thumbVertical ? viewport.scrollHeight - viewport.clientHeight : viewport.scrollWidth - viewport.clientWidth;
        this.thumbButtons.forEach(button => {
          button.disabled = button.dataset.ab2bThumbDirection === '-1' ? position <= 1 : position >= maximum - 1;
        });
      }
      revealThumb() {
        if (!this.thumbViewport || this.thumbNav.dataset.mode === 'all') return;
        const thumb = this.thumbs.find(item => item.getAttribute('aria-current') === 'true');
        if (!thumb) return;
        const item = thumb.getBoundingClientRect();
        const viewport = this.thumbViewport.getBoundingClientRect();
        const start = this.thumbVertical ? item.top - viewport.top - 4 : item.left - viewport.left - 4;
        const end = this.thumbVertical ? item.bottom - viewport.bottom + 4 : item.right - viewport.right + 4;
        const offset = start < 0 ? start : end > 0 ? end : 0;
        if (this.thumbVertical && offset !== 0) {
          const gap = parseFloat(getComputedStyle(this.thumbViewport).gap) || 0;
          const stride = item.height + gap;
          const visible = Math.max(1, Math.floor((this.thumbViewport.clientHeight - 8 + gap) / stride));
          const index = this.thumbs.indexOf(thumb);
          this.thumbViewport.scrollTop = Math.max(0, (start < 0 ? index : index - visible + 1) * stride);
        }
        else if (!this.thumbVertical) this.thumbViewport.scrollLeft += offset;
      }
      scrollThumbs(direction) {
        if (!this.thumbViewport || !this.thumbs.length) return;
        const rect = this.thumbs[0].getBoundingClientRect();
        const styles = getComputedStyle(this.thumbViewport);
        const distance = (this.thumbVertical ? rect.height : rect.width) + parseFloat(styles.gap);
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        const rtl = styles.direction === 'rtl' ? -1 : 1;
        this.thumbViewport.scrollBy({ top: this.thumbVertical ? direction * distance : 0, left: this.thumbVertical ? 0 : direction * distance * rtl, behavior });
      }
      selectVariant(id) {
        const variant = this.data.variants.find(item => String(item.id) === String(id));
        if (!variant) return;
        const inputs = [...this.querySelectorAll('[data-ab2b-native-option]')];
        inputs.forEach((input, index) => { input.value = variant.options[index]; });
        // Notify the theme once, after setting the complete combination.
        inputs[0]?.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncVariant() {
        const variant = this.current;
        this.querySelectorAll('[data-ab2b-variant]').forEach(input => { input.checked = String(input.value) === String(variant?.id); });
        this.querySelectorAll('[data-ab2b-variant-id]').forEach(input => {
          input.value = variant?.id || '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        this.querySelectorAll('[data-ab2b-contact-variant]').forEach(input => { input.value = variant?.title || this.data.unavailableLabel; });
        this.querySelectorAll('[data-ab2b-contact-sku]').forEach(input => { input.value = variant?.sku || ''; });
        this.querySelectorAll('[data-ab2b-product-url]').forEach(input => { input.value = variant?.url || ''; });
        const subtitle = this.querySelector('[data-ab2b-variant-title]');
        if (subtitle) subtitle.textContent = variant && variant.title !== 'Default Title' ? ` — ${variant.title}` : '';
        this.querySelectorAll('[data-add-to-cart-text]').forEach(label => {
          label.textContent = !variant ? this.data.unavailableLabel : variant.available ? this.data.buyLabel : this.data.soldOutLabel;
        });
        this.querySelectorAll('[data-add-to-cart]').forEach(button => { button.disabled = !variant?.available; });
        this.querySelectorAll('[data-ab2b-quantity]').forEach(input => {
          const minimum = variant?.minimum || 1;
          const increment = variant?.increment || 1;
          input.min = minimum;
          input.step = increment;
          if (variant?.maximum != null) input.max = variant.maximum;
          else input.removeAttribute('max');
          const quantity = Number(input.value);
          if (!Number.isFinite(quantity) || quantity < minimum || (quantity - minimum) % increment !== 0 || (variant?.maximum != null && quantity > variant.maximum)) input.value = minimum;
        });
      }
      onClick(event) {
        const thumbArrow = event.target.closest('[data-ab2b-thumb-direction]');
        if (thumbArrow) {
          event.preventDefault();
          this.scrollThumbs(Number(thumbArrow.dataset.ab2bThumbDirection));
          return;
        }
        const purchase = event.target.closest('[data-add-to-cart]');
        if (purchase) {
          const form = purchase.closest('form');
          const gated = form?.querySelector('[data-c24h-purchase-gated]');
          if (!this.current?.available || gated?.hidden || gated?.hasAttribute('inert') || !form?.reportValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
        }
        if (event.target.closest('[data-ab2b-quote-trigger][aria-disabled=true]')) { event.preventDefault(); return; }
        const thumb = event.target.closest('[data-ab2b-thumbnail]');
        if (thumb && this.nativeSlider) {
          event.preventDefault();
          this.selectMedia(thumb.dataset.ab2bThumbnail);
          return;
        }
        const trigger = event.target.closest('[data-ab2b-quote-trigger]');
        if (trigger && this.dialog?.hasAttribute('data-modal-ready') && trigger.hash === `#${this.dialog.id}`) {
          event.preventDefault();
          this.trigger = trigger;
          const finance = this.dialog.querySelector('[data-ab2b-finance-option]');
          if (finance && trigger.hasAttribute('data-ab2b-financing')) finance.checked = true;
          this.openQuote();
        }
        if (event.target.closest('[data-ab2b-close]')) this.dialog?.close();
      }
      onKeydown(event) {
        const thumb = event.target.closest('[data-ab2b-thumbnail]');
        if (!thumb || !this.nativeSlider) return;
        const delta = { ArrowLeft: -1, ArrowUp: -1, ArrowRight: 1, ArrowDown: 1 }[event.key];
        let index = this.thumbs.indexOf(thumb);
        if (delta) index = (index + delta + this.thumbs.length) % this.thumbs.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.thumbs.length - 1;
        else if (event.key === ' ') { event.preventDefault(); thumb.click(); return; }
        else return;
        event.preventDefault();
        this.thumbs[index].focus();
        this.thumbs[index].click();
      }
      openQuote() {
        if (!this.dialog || this.dialog.open) return;
        this.pauseMedia();
        this.dialog.showModal();
        this.dialog.querySelector('[data-ab2b-form-result], input:not([type=hidden])')?.focus();
      }
      onSubmit(event) {
        if (!event.target.matches('[data-product-form]')) return;
        const controls = event.target.querySelector('[data-c24h-purchase-gated]');
        if (!this.current?.available || controls?.hidden || controls?.hasAttribute('inert')) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }
      pauseMedia() {
        this.querySelectorAll('video').forEach(video => video.pause());
        this.querySelectorAll('[data-product-single-media-wrapper]').forEach(media => media.dispatchEvent(new CustomEvent('theme:media:hidden')));
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
        this.observer?.disconnect();
        this.thumbResize?.disconnect();
        cancelAnimationFrame(this.thumbFrame);
        cancelAnimationFrame(this.galleryFrame);
        this.pauseMedia();
        if (this.dialog?.open) this.dialog.close();
        this.nativeSlider?.off('select', this.onChange);
        this.nativeSlider?.destroy();
        this.nativeSlider = null;
      }
    }
    customElements.define('aparatologia-b2b', AparatologiaB2b);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-mejorado"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!window.UPNGProductMejorado) {
    class ProductController {
      constructor(root) {
        this.root = root;
        this.data = JSON.parse(root.querySelector('[data-upng-product-data]').textContent);
        this.variants = new Map(this.data.variants.map(variant => [String(variant.id), variant]));
        this.panels = new Map([...root.querySelectorAll('[data-upng-media-id]')].map(panel => [panel.dataset.upngMediaId, panel]));
        this.thumbnails = [...root.querySelectorAll('[data-upng-thumbnail]')];
        this.abort = new AbortController();
        this.modelUIs = new Map();
        this.currentVariant = null;
        this.activeMediaId = null;
        this.syncing = false;
        root.upngProduct = this;
        const options = { signal: this.abort.signal };
        root.addEventListener('change', event => this.onChange(event), options);
        root.addEventListener('click', event => this.onClick(event), options);
        root.addEventListener('keydown', event => this.onKeyDown(event), options);
        ['theme:variant:change', 'variant:change', 'variant:changed', 'on:variant:change'].forEach(name => {
          root.addEventListener(name, event => {
            if (this.syncing || event.detail?.source === 'upng-b2b') return;
            const id = event.detail?.variant?.id || event.detail?.variantId;
            if (id && this.variants.has(String(id))) this.selectVariant(id, { updateUrl: false });
          }, options);
        });
        window.addEventListener('popstate', () => {
          const id = new URL(window.location.href).searchParams.get('variant') || this.data.initialVariantId;
          this.selectVariant(id, { updateUrl: false });
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.pausePanel(this.panels.get(this.activeMediaId));
          else this.showMedia(this.activeMediaId);
        }, options);
        this.selectVariant(this.data.initialVariantId, { updateUrl: false, notify: false });
        this.connectNativeGallery();
        this.syncQuantities();
        this.updateGallerySizes();
        this.onGalleryResize = () => {
          cancelAnimationFrame(this.galleryFrame);
          this.galleryFrame = requestAnimationFrame(() => { this.connectNativeGallery(); this.updateGallerySizes(); });
        };
        window.addEventListener('resize',this.onGalleryResize,options);
        document.addEventListener('theme:resize:width',this.onGalleryResize,options);
        if (window.ResizeObserver) {
          this.gallerySizeObserver = new ResizeObserver(() => this.updateGallerySizes());
          const gallery = root.querySelector('[data-upng-native-slider]');
          if (gallery) this.gallerySizeObserver.observe(gallery);
        }
        document.addEventListener('DOMContentLoaded', () => this.connectNativeGallery(), options);
        window.addEventListener('load', () => this.connectNativeGallery(), options);
        this.galleryObserver = new MutationObserver(() => this.connectNativeGallery());
        const nativeSlider = root.querySelector('[data-upng-native-slider]');
        if (nativeSlider) this.galleryObserver.observe(nativeSlider, { attributes:true, attributeFilter:['class'] });
        root.addEventListener('input', event => { if (event.target.matches('[data-upng-quantity-input]')) this.syncQuantities(); }, options);
        root.addEventListener('click', event => this.prepareCart(event), { ...options, capture:true });
        root.addEventListener('submit', event => this.prepareCart(event), { ...options, capture:true });
        root.addEventListener('playing', event => { const panel=event.target.closest('[data-upng-media-id]'); if (panel?.dataset.upngMediaId !== this.activeMediaId) { if (this.mediaGridVisible()) this.showMedia(panel.dataset.upngMediaId); else event.target.pause(); } }, { ...options, capture:true });

      }

      mediaForVariant(variant) {
        const id = variant && (this.data.variantMedia[String(variant.id)] || variant.featured_media?.id);
        return this.panels.has(String(id)) ? String(id) : String(this.data.defaultMediaId || '');
      }

      onChange(event) {
        if (this.syncing) return;
        if (event.target.matches('[data-upng-bulk-select]')) { this.selectVariant(event.target.value); return; }
        if (event.target.matches('[data-upng-quantity-input]')) { this.syncQuantities(); return; }
        if (event.target.matches('[data-upng-option-input], [data-upng-option-select]')) {
          const container = event.target.closest('[data-upng-options]');
          const values = [...container.querySelectorAll('[data-upng-option-position]')].map(fieldset =>
            fieldset.querySelector('[data-upng-option-select], [data-upng-option-input]:checked')?.value
          );
          const variant = this.data.variants.find(candidate => candidate.options.every((value, i) => value === values[i]));
          this.selectVariant(variant?.id);
        } else if (event.target.matches('input[name="id"], select[name="id"]') && this.variants.has(event.target.value)) {
          this.selectVariant(event.target.value);
        }
      }

      onClick(event) {
        const poster = event.target.closest('[data-deferred-media-button]');
        if (poster && this.mediaGridVisible()) this.showMedia(poster.closest('[data-upng-media-id]').dataset.upngMediaId);
        const step = event.target.closest('[data-upng-step]');
        if (step) { this.stepQuantity(step); return; }
        const thumb = event.target.closest('[data-upng-thumbnail]');
        if (thumb && this.root.contains(thumb)) {
          const id = thumb.dataset.upngThumbnail;
          this.showMedia(id, true);
          const candidates = this.data.variants.filter(variant => String(this.data.variantMedia[String(variant.id)] || '') === id);
          if (candidates.some(variant => variant.id === this.currentVariant?.id)) return;
          if (candidates.length === 1) {
            this.selectVariant(candidates[0].id);
          } else if (candidates.length > 1 && this.currentVariant) {
            const scored = candidates.map(variant => ({
              variant,
              score: variant.options.reduce((total, value, i) => total + Number(value === this.currentVariant.options[i]), 0)
            })).sort((a, b) => b.score - a.score);
            if (scored[0].score > scored[1].score) this.selectVariant(scored[0].variant.id);
          }
          return;
        }
        const arrow = event.target.closest('[data-upng-scroll]');
        if (!arrow) return;
        const list = this.root.querySelector('[data-upng-thumbnails]');
        const offset = Number(arrow.dataset.upngScroll) * 180;
        const horizontal = window.getComputedStyle(list).flexDirection === 'row';
        list?.scrollBy({ left: horizontal ? offset : 0, top: horizontal ? 0 : offset, behavior: 'smooth' });
      }

      onKeyDown(event) {
        const thumb = event.target.closest('[data-upng-thumbnail]');
        if (!thumb || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let index = this.thumbnails.indexOf(thumb);
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.thumbnails.length - 1;
        else index = (index + (['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1) + this.thumbnails.length) % this.thumbnails.length;
        this.thumbnails[index].focus();
        this.thumbnails[index].click();
      }

      pausePanel(panel) {
        if (!panel) return;
        panel.querySelectorAll('video').forEach(video => video.pause());
        panel.dispatchEvent(new CustomEvent('theme:media:hidden'));
      }
      mediaGridVisible() {
        return this.root.dataset.galleryLayout !== 'carousel' && window.matchMedia('(min-width: 1024px)').matches;
      }
      updateGallerySizes() {
        const slider = this.root.querySelector('[data-upng-native-slider]');
        if (!slider) return;
        const columns = this.mediaGridVisible() && this.root.dataset.galleryLayout === 'columns' ? 2 : 1;
        const hover = this.root.dataset.imageZoom === 'hover' ? 1.7 : 1;
        const width = Math.max(0, Math.ceil((slider.getBoundingClientRect().width - (columns===2 ? 12 : 0)) / columns * hover));
        if (!width || width === this.galleryImageWidth) return;
        this.galleryImageWidth = width;
        slider.querySelectorAll('img').forEach(image => image.sizes = width + 'px');
        this.nativeGallery?.resize();
      }
      connectNativeGallery() {
        const slider = this.root.querySelector('[data-upng-native-slider]');
        const native = window.themeVendor?.Flickity?.data(slider);
        if (!native || this.mediaGridVisible()) {
          this.nativeGallery?.off('select',this.onNativeSelect);
          this.nativeGallery = null;
          if (native?.isActive) native.deactivate();
          this.showMedia(this.activeMediaId);
          return;
        }
        if (!native.isActive) native.activate();
        if (native === this.nativeGallery) return;
        this.nativeGallery?.off('select',this.onNativeSelect);
        this.nativeGallery = native;
        this.onNativeSelect = () => this.showMedia(native.selectedElement?.dataset.upngMediaId);
        native.on('select', this.onNativeSelect);
        this.showMedia(this.activeMediaId || this.mediaForVariant(this.currentVariant));
      }
      showMedia(id, scroll = false) {
        const active = this.panels.get(String(id)) || this.panels.get(String(this.data.defaultMediaId)) || this.panels.values().next().value;
        if (!active) return;
        this.activeMediaId = active.dataset.upngMediaId;
        if (this.nativeGallery && this.nativeGallery.selectedElement !== active) this.nativeGallery.selectCell(active, false, true);
        this.panels.forEach(panel => {
          const selected = panel === active;
          const visible = selected || this.mediaGridVisible();
          if (!selected) this.pausePanel(panel);
          panel.classList.toggle('media--hidden', !visible);
          panel.setAttribute('aria-hidden', String(!visible));
          panel.querySelectorAll('a,button').forEach(control => control.setAttribute('tabindex', visible ? '0' : '-1'));
        });
        this.thumbnails.forEach(thumb => {
          const selected = thumb.dataset.upngThumbnail === this.activeMediaId;
          thumb.classList.toggle('active', selected);
          thumb.setAttribute('aria-current', String(selected));
          if (selected && scroll) {
            const list = thumb.parentElement;
            list.scrollTo({left:Math.max(0,thumb.offsetLeft-list.offsetLeft-(list.clientWidth-thumb.clientWidth)/2),top:Math.max(0,thumb.offsetTop-list.offsetTop-(list.clientHeight-thumb.clientHeight)/2),behavior:'smooth'});
          }
        });
      }
      quantityValid(input) {
        const group = input.closest('[data-upng-quantity]');
        const value = Number(input.value), minimum = Number(group.dataset.minimum), increment = Number(group.dataset.increment);
        return Number.isSafeInteger(value) && ((group.dataset.zero === 'true' && value === 0) ||
          (value >= minimum && (value-minimum)%increment === 0)) && (!input.hasAttribute('max') || value <= Number(input.max));
      }
      stepQuantity(button) {
        const group = button.closest('[data-upng-quantity]'), input = group.querySelector('input');
        if (button.disabled || input.disabled || group.closest('[inert]')) return;
        const minimum = Number(group.dataset.minimum), increment = Number(group.dataset.increment), zero = group.dataset.zero === 'true';
        const value = this.quantityValid(input) ? Number(input.value) : (zero ? 0 : minimum);
        const next = Number(button.dataset.upngStep) > 0 ? (value === 0 ? minimum : value+increment) : (value === minimum && zero ? 0 : Math.max(zero?0:minimum,value-increment));
        if (input.hasAttribute('max') && next > Number(input.max)) return;
        input.value = next;
        input.dispatchEvent(new Event('change',{bubbles:true}));
      }
      syncQuantities() {
        this.root.querySelectorAll('[data-upng-quantity]').forEach(group => {
          const input = group.querySelector('input'), value = Number(input.value), valid = this.quantityValid(input);
          input.setCustomValidity(valid ? '' : 'Revisa la cantidad mínima, el incremento y las unidades disponibles.');
          group.querySelector('[data-upng-step="-1"]').disabled = input.disabled || value <= (group.dataset.zero === 'true' ? 0 : Number(group.dataset.minimum));
          group.querySelector('[data-upng-step="1"]').disabled = input.disabled || (input.hasAttribute('max') && (value===0?Number(group.dataset.minimum):value+Number(group.dataset.increment)) > Number(input.max));
          input.closest('[data-upng-bulk-row]')?.classList.toggle('has-quantity', valid && value>0);
        });
        this.root.querySelectorAll('[data-upng-bulk-form]').forEach(form => {
          const inputs = [...form.querySelectorAll('[data-upng-bulk-quantity]')];
          form.querySelector('[data-upng-bulk-submit]').disabled = !inputs.some(input => !input.disabled && this.quantityValid(input) && Number(input.value)>0);
        });
      }
      prepareCart(event) {
        const button = event.type === 'click' ? event.target.closest('[data-add-to-cart]') : null;
        const form = event.type === 'submit' ? event.target : button?.closest('form');
        if (!form?.matches('[data-upng-bulk-form], [data-upng-single-form]')) return;
        const reject = () => { event.preventDefault(); event.stopImmediatePropagation(); };
        const locked = [...form.querySelectorAll('[data-c24h-purchase-gated]')].some(node => node.hidden || node.hasAttribute('inert'));
        if (locked || button?.disabled || !form.reportValidity()) { reject(); return; }
        if (!form.matches('[data-upng-bulk-form]')) return;
        const inputs = [...form.querySelectorAll('[data-upng-bulk-quantity]')].filter(input => !input.disabled && Number(input.value)>0);
        if (!inputs.length || inputs.some(input => !this.quantityValid(input) || !this.variants.get(input.dataset.variantId)?.available)) {
          form.querySelector('[data-upng-bulk-error]').textContent = 'Indica una cantidad válida en al menos una variante.';
          reject(); return;
        }
        form.querySelector('[data-upng-bulk-error]').textContent = '';
        form.querySelectorAll('[data-upng-cart-item]').forEach(input => input.remove());
        inputs.forEach((input,index) => {
          for (const [field,value] of [['id',input.dataset.variantId],['quantity',input.value]]) {
            const hidden = document.createElement('input');
            hidden.type='hidden'; hidden.name='items['+index+']['+field+']'; hidden.value=value; hidden.setAttribute('data-upng-cart-item',''); form.append(hidden);
          }
        });
      }

      selectVariant(id, { updateUrl = true, notify = true } = {}) {
        if (this.syncing) return;
        const variant = this.variants.get(String(id)) || null;
        this.syncing = true;
        try {
          this.currentVariant = variant;
          this.root.dataset.upngVariantId = variant ? String(variant.id) : '';
          if (variant) {
            this.root.querySelectorAll('[data-upng-option-position]').forEach(fieldset => {
              const value = variant.options[Number(fieldset.dataset.upngOptionPosition) - 1];
              fieldset.querySelectorAll('[data-upng-option-input]').forEach(input => {
                input.checked = input.value === value;
                input.labels?.forEach(label => label.classList.toggle('selected', input.checked));
              });
              const select = fieldset.querySelector('[data-upng-option-select]');
              if (select) select.value = value;
              const label = fieldset.querySelector('.selected-variant-name');
              if (label) label.textContent = value;
            });
          } else {
            this.root.querySelectorAll('[data-upng-option-position]').forEach(fieldset => {
              const value = fieldset.querySelector('[data-upng-option-select], [data-upng-option-input]:checked')?.value || '';
              const label = fieldset.querySelector('.selected-variant-name');
              if (label) label.textContent = value;
              fieldset.querySelectorAll('[data-upng-option-input]').forEach(input => input.labels?.forEach(item => item.classList.toggle('selected', input.checked)));
            });
          }
          this.root.querySelectorAll('[data-upng-bulk-row]').forEach(row => {
            const selected = row.dataset.variantId === String(variant?.id);
            row.classList.toggle('upng-variant-selected',selected);
            row.querySelector('[data-upng-bulk-select]').checked=selected;
          });
          this.root.querySelectorAll('input[name="id"], select[name="id"]').forEach(input => {
            const value = variant ? String(variant.id) : '';
            if (input.value !== value) {
              input.value = value;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
          this.updatePrice(variant);
          this.root.querySelectorAll('form[action*="/cart/add"] [name="add"]').forEach(button => {
            const text = button.querySelector('[data-add-to-cart-text]');
            if (text && !button.dataset.upngAvailableText) button.dataset.upngAvailableText = text.textContent;
            button.disabled = !variant?.available;
            if (text) text.textContent = !variant ? this.data.unavailable : !variant.available ? this.data.soldOut : button.dataset.upngAvailableText;
          });
          this.showMedia(this.mediaForVariant(variant), notify);
          if (variant) {
            this.root.querySelectorAll('[data-delivery-container]').forEach(container => {
              if (typeof window.initDeliveryMessage === 'function') window.initDeliveryMessage(container, String(variant.id));
            });
          }
          if (updateUrl) {
            const url = new URL(window.location.href);
            if (variant) url.searchParams.set('variant', variant.id);
            else url.searchParams.delete('variant');
            url.searchParams.delete('option_values');
            window.history.replaceState(window.history.state, '', url);
          }
          if (notify) {
            this.root.dispatchEvent(new CustomEvent('theme:variant:change', {
              bubbles: true, detail: { variant, source: 'upng-b2b' }
            }));
          }
        } finally {
          this.syncing = false;
        }
      }

      updatePrice(variant) {
        const formatted = variant && this.data.formatted[String(variant.id)];
        const onSale = Boolean(variant && variant.compare_at_price > variant.price);
        this.root.querySelectorAll('[data-product-price]').forEach(node => {
          if (formatted) node.innerHTML = formatted.price;
          else node.textContent = this.data.unavailable;
          node.classList.toggle('product__price--sale', onSale);
        });
        this.root.querySelectorAll('[data-compare-price]').forEach(node => {
          node.innerHTML = onSale ? formatted.compare : '';
          node.style.display = onSale ? '' : 'none';
        });
        this.root.querySelectorAll('[data-price-off]').forEach(node => node.classList.toggle('hidden', !onSale));
        this.root.querySelectorAll('[data-price-off-amount]').forEach(node => { node.innerHTML = onSale ? formatted.saving : ''; });
        this.root.querySelectorAll('[data-product-unit]').forEach(node => node.classList.toggle('hidden', !variant?.unit_price));
        this.root.querySelectorAll('[data-product-unit-price]').forEach(node => { node.innerHTML = formatted?.unit || ''; });
        this.root.querySelectorAll('[data-product-base]').forEach(node => { node.textContent = formatted?.unitBase || ''; });
      }

      destroy() {
        this.galleryObserver?.disconnect();
        this.gallerySizeObserver?.disconnect();
        cancelAnimationFrame(this.galleryFrame);
        this.nativeGallery?.off('select',this.onNativeSelect);
        this.abort.abort();
        this.panels.forEach(panel => this.pausePanel(panel));
        this.modelUIs.forEach(ui => ui.destroy?.());
        delete this.root.upngProduct;
      }
    }
    const init = container => {
      const roots = [...container.querySelectorAll('[data-upng-product-mejorado]')];
      if (container.matches?.('[data-upng-product-mejorado]')) roots.unshift(container);
      roots.forEach(root => { if (!root.upngProduct) new ProductController(root); });
    };
    window.UPNGProductMejorado = { init };
    document.addEventListener('shopify:section:load', event => init(event.target));
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll('[data-upng-product-mejorado]').forEach(root => root.upngProduct?.destroy());
      event.target.upngProduct?.destroy();
    });
  }
  window.UPNGProductMejorado.init(document);
})();

  } catch(e) { console.error(e); }
})();
})();
